// @ts-nocheck

export const IgnoredErrors = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  'Load timeout for modules:',
  'Script error for:',
  'Non-Error promise rejection captured',
  'NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
];

export const IgnoredUrls = [/widgets\.sir\.sportradar\.com/i];
